<p>redirect-mask works!</p>
